import { toast } from "sonner"

export const successToast = (message: string) => {
  toast.success(message, { id: message })
}

export const infoToast = (message: string) => {
  toast.info(message, { id: message })
}

export const errorToast = (message: string) => {
  toast.error(message, { id: message, duration: 8000 })
}
